var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMuteSmallButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 25.781,
    viewBox: "0 0 21 25.781",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15407",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15407",
    transform: "translate(-780.5 -711.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15394",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15394",
    transform: "translate(781.5 711.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u524D\\u9762\\u30AA\\u30D6\\u30B8\\u30A7\\u30AF\\u30C8\\u3067\\u578B\\u629C\\u304D_1",
    "data-name": "\\u524D\\u9762\\u30AA\\u30D6\\u30B8\\u30A7\\u30AF\\u30C8\\u3067\\u578B\\u629C\\u304D 1",
    d: "M5.156,16.758A5.157,5.157,0,0,1,0,11.6V8.734l7.475,7.474A5.1,5.1,0,0,1,5.156,16.758ZM8.84,15.21h0L0,6.37V5.156A5.156,5.156,0,0,1,8.8,1.51a5.123,5.123,0,0,1,1.51,3.646V11.6A5.126,5.126,0,0,1,8.84,15.209Z",
    transform: "translate(3.867 0)",
    fill: "#f2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u524D\\u9762\\u30AA\\u30D6\\u30B8\\u30A7\\u30AF\\u30C8\\u3067\\u578B\\u629C\\u304D_2",
    "data-name": "\\u524D\\u9762\\u30AA\\u30D6\\u30B8\\u30A7\\u30AF\\u30C8\\u3067\\u578B\\u629C\\u304D 2",
    d: "M13.033,15.469H5.015a1.149,1.149,0,0,1-1.148-1.148v-.284a1.148,1.148,0,0,1,1.148-1.146h2.72V10.209A9.023,9.023,0,0,1,0,1.289a1.289,1.289,0,1,1,2.578,0A6.454,6.454,0,0,0,6.514,7.228a6.412,6.412,0,0,0,2.509.507,6.44,6.44,0,0,0,3.268-.889l1.859,1.86a8.938,8.938,0,0,1-3.838,1.5v2.681h2.72a1.147,1.147,0,0,1,1.146,1.146v.284A1.148,1.148,0,0,1,13.033,15.469Zm2.4-7.842h0L13.618,5.808a6.409,6.409,0,0,0,1.85-4.519,1.289,1.289,0,0,1,2.578,0,9.007,9.007,0,0,1-2.61,6.337Z",
    transform: "translate(0 10.313)",
    fill: "#f2d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u7DDA_633",
    "data-name": "\\u7DDA 633",
    d: "M19,20.273a1,1,0,0,1-.712-.3L-.712.7A1,1,0,0,1-.7-.712,1,1,0,0,1,.712-.7l19,19.273a1,1,0,0,1-.712,1.7Z",
    transform: "translate(781.5 712.227)",
    fill: "#fe22dc"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteSmallButton);
export default __webpack_public_path__ + "static/media/muteSmallButton.e1e3be2d565c072ffa7597bfe1f59659.svg";
export { ForwardRef as ReactComponent };